import { CommissionService } from '@app/shared/components/requests/commissions/service/commission.service';
import { Component, OnInit, Inject, Input, ViewEncapsulation } from '@angular/core';
import { CommissionResult } from '../../models';
import { APP_CONFIG, IAppConfig } from '@app/core/config';
import { CommissionType } from '@app/shared/types';
import { CommissionCalcType } from '../../types/commission-calc-type.enum';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TcCurrencyPipe } from '@app/shared/pipes';

@Component({
    selector: 'tc-invoice-exchange-first',
    imports: [
        CommonModule,
        TranslateModule,
        TcCurrencyPipe,
    ],
    templateUrl: './invoice-exchange-first.component.html',
    styleUrls: ['./invoice-exchange-first.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class InvoiceExchangeFirstComponent implements OnInit {
  @Input() commission: CommissionResult;
  @Input() rowCountIsEven: boolean;
  @Input() getAmountTitle: string;
  @Input() payAmountTitle: string;
  @Input() isDetailMode: boolean;
  pointPrecision: number;

  // types
  commissionType = CommissionType;
  commissionCalcType = CommissionCalcType;
  constructor(
    @Inject(APP_CONFIG) private appConfig: IAppConfig,
    private commissionService: CommissionService
  ) {}

  ngOnInit() {
    this.pointPrecision = this.appConfig.pointPrecision;
    if(!this.commission){
      this.commission = this.commissionService.commissionResult;
    }
  }

}
